import { render } from "./CharlaLandingBlock.vue?vue&type=template&id=2470044a&scoped=true"
import script from "./CharlaLandingBlock.vue?vue&type=script&lang=js"
export * from "./CharlaLandingBlock.vue?vue&type=script&lang=js"

import "./CharlaLandingBlock.vue?vue&type=style&index=0&id=2470044a&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2470044a"]])

export default __exports__